export enum BOOKMARKS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=67172311
     */
    LOAD_ERROR = 'FRONT.BOOKMARKS.LOAD_ERROR',
}
